import { CardBody, CardHeader } from "reactstrap";
import styled from "styled-components";

export const PathwayCardHeader = styled(CardHeader)`
    display: grid;
    align-items: center;
    justify-content: space-between;
    grid-template-columns: auto max-content;

    & > h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
        margin: 0;
    }
`;

export const PathwayButtonRow = styled.div`
    display: inline-grid;
    align-items: center;
    grid-template-columns: repeat(auto-fit, minmax(150px, max-content));
    grid-auto-flow: column dense;

    column-gap: var(--gap-m);
    row-gap: var(--gap-m);
    justify-content: end;
`;

export const PathwayCardBody = styled(CardBody)`
    display: grid;
    grid-template-rows: auto;
    row-gap: var(--gap-m);
    column-gap: var(--gap-m);
    align-content: start;

    & p {
        margin: 0;
    }
`;
